<template>
  <div class="radio-input">
    <fieldset class="form-group">
      <div class="row">
        <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
          {{ options.label }}
          <span v-if="options.required" class="required">*</span>
        </label>
        <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
          <div class="row">
            <div
              class="form-check"
              :class="{ 'form-check-inline': options.inline, 'col-sm': true }"
              v-for="(radio, index) in options.radios"
              :key="index">
              <input
                class="form-check-input"
                type="radio"
                :id="radio.name + options.index"
                :value="radio.value"
                @change="validate($event.target.value)"
                :checked="value === radio.value"
                :name="radio.name + options.index"/>
              <label class="form-check-label" :for="radio.name + options.index">
                {{ radio.label }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: 'RadioInput',
  props: {
    value: {
      type: [String, Number]
    },
    options: {
      type: Object,
      default () {
        return {
          index: 0,
          radios: [],
          value: ''
        }
      }
    }
  },
  data () {
    return {
      isValid: false,
      isDirty: false
    }
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      this.isValid = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/RadioInput.vue